// extracted by mini-css-extract-plugin
export default {"firstSection":"Content_firstSection__fpXWd","firstSectionLayout":"Content_firstSectionLayout__4CrlO","textContainer":"Content_textContainer__hzjpG"};